import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Logger from 'data/common/Logger';
import api from './api';
/** @var ApiCall apiCaller */
const apiCaller = getApiInstance();

export function getHomeGenerators(env, homeId) {
    return dispatch => {
        return apiCaller
            .call(api.getHomeGenerators(env, homeId))
            .then(({ data }) => {
                if (data.success) {
                    if (data.homeGenerators) {
                        dispatch({
                            type: `${env.toUpperCase()}__UPDATE_HOME_GENERATORS`,
                            homeId,
                            homeGenerators: data.homeGenerators,
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getHomeGenerators - ', error);
                throw error;
            });
    };
}
export function addHomeGenerator(env, homeId, generator) {
    return dispatch => {
        return apiCaller
            .call(api.addHomeGenerator(env, homeId, generator))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_HOME_GENERATORS`,
                        homeId,
                        homeGenerators: data.homeGenerators
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: addHomeGenerator - ', error);
                throw error;
            });
    };
}
export function updateHomeGenerator(env, homeId, generatorId, generator) {
    return dispatch => {
        return apiCaller
            .call(api.updateHomeGenerator(env, homeId, generatorId, generator))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_HOME_GENERATORS`,
                        homeId,
                        homeGenerators: data.homeGenerators
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateHomeGenerator - ', error);
                throw error;
            });
    };
}
export function deleteHomeGenerator(env, homeId, generatorId) {
    return dispatch => {
        return apiCaller
            .call(api.deleteHomeGenerator(env, homeId, generatorId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__DELETE_HOME_GENERATOR`,
                        homeId,
                        generatorId
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: deleteHomeGenerator - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Generators/actions.js